<template>
  <div class="show-for-medium operations-accordion">
    <Accordion
      v-for="accordion in accordionItems"
      :key="accordion.name"
      :active="accordion.active"
      :modifiers="['full-width-header']"
    >
      <template #header-main>
        <div
          :aria-label="`${accordion.name} label`"
          class="operations-accordion__header"
        >
          <component
            :is="iconType[accordion.name.toLowerCase()]"
            class="icon operations-accordion__icon"
          />
          <div class="operations-accordion__header-label">
            {{ accordion.name }}
          </div>
        </div>
      </template>
      <template #content>
        <router-link
          v-for="content in accordion.links"
          :key="content.name"
          activeClass="nav-sub-links--active"
          :aria-label="content.type"
          class="typo-small-title nav-sub-links"
          :to="{
            name: content.name,
            params: { issueType: content.type },
          }"
        >
          {{ content.label }}
        </router-link>
      </template>
    </Accordion>
  </div>
</template>

<script setup>
// Components
// TODO: Break this component out into a more generic one. eg. not user related
import Accordion from '@/components/users/user_accordion.vue';

// Icons
import HMEIcon from '@/images/digger_icon_small_white.svg';
import SetIcon from '@/images/set_icon_small_white.svg';
import StationIcon from '@/images/doors_icon_small_white.svg';

defineProps({
  /** Navigation list */
  accordionItems: { type: Array, required: true, default: () => [] },
});

const iconType = {
  'assets': HMEIcon,
  'sets': SetIcon,
  'stations': StationIcon,
  'plant': SetIcon,
};
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.operations-accordion {
  border-bottom: 2px solid map-get($background-color, dark);
  display: flex;
  flex-direction: column;
  justify-items: center;
  max-height: rem(275);
  overflow: auto;
  padding: bu(0.5);

  &__header {
    display: flex;
    width: 100%;
    overflow: hidden;
  }

  &__header-label {
    @include text-overflow;
  }

  &__icon {
    margin-right: bu(1);
  }
}

.nav-sub-links {
  border-radius: map-get($border-radius, heavy);
  display: block;
  margin-bottom: bu(0.5);
  margin-left: bu(1);
  padding: bu(1);

  &--active {
    background-color: map-get($background-color, dark);
  }
}
</style>
